import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { POST_ADD_ROOM } from '@app/constants/rooms/rooms'
import Api from '@app/api/rooms'
import { apiRequestSent, apiRequestDone, apiRequestFailed } from '@app/actions/apiRequest'
import { setPostNewRoom, postAddRoomFailedPopup } from '@app/actions/rooms/rooms'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'

const postRoom = createLogic({
  type: POST_ADD_ROOM,
  cancelType: API_REQUEST_CANCEL,

  process({ action }, dispatch, done) {
    const { secrets: { accessToken: { token: AccessToken } } } = store.getState()
    dispatch(apiRequestSent(POST_ADD_ROOM))
    Api.postRoom(AccessToken, action.data)
      .then((response) => {
        dispatch(setPostNewRoom(response.data.room))
        dispatch(apiRequestDone(POST_ADD_ROOM))
      })
      .catch((error) => {
        if (error) {
          const currentError = handleErrors(error)
          dispatch(apiRequestFailed(currentError))
          dispatch(postAddRoomFailedPopup())
        } else {
          throw new Error('postRoom failed without error')
        }
      })
      .then(() => done())
  },
})

export default postRoom
